import { render, staticRenderFns } from "./HomeWidgetSingleEntryModal.vue?vue&type=template&id=52b5a0f0&"
import script from "./HomeWidgetSingleEntryModal.vue?vue&type=script&lang=js&"
export * from "./HomeWidgetSingleEntryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports